import React, {FC} from 'react'
import {Link} from "react-router-dom"
import {useSelector} from "react-redux"
import MetaTags from 'react-meta-tags'
import * as Yup from "yup"
import {useAppContext} from "../../AppContext"
import useValidatedFields from "../../hooks/useValidatedFields"
import useFormActions from "../../hooks/useFormActions"
import getLocalizeString from "../../utils/getLocalizeString"
import Form from '../Form'
import Input from '../Input'
import Captcha from '../Captcha'
import Button from '../Button'

const Login: FC = () => {
  const initFields = {
    login: '',
    password: ''
  }
  const initValidators = {
    login: Yup.string()
      .required('Field can not be empty'),
    password: Yup.string()
      .required('Field can not be empty')
  }
  const {formFields, formValidators} = useValidatedFields(initFields, initValidators)
  const {submitLogin} = useFormActions()
  const {appType} = useAppContext()
  const showCaptcha = useSelector(({reducer}: any) => reducer.showCaptcha)

  return (
    <>
      <MetaTags>
        <title>{getLocalizeString('Sign in')}</title>
      </MetaTags>

      <Form
        title={'Log in '}
        withSocial
        initFields={formFields}
        validationSchema={Yup.object().shape(formValidators)}
        nav={[
          {
            link: '/login',
            title: 'Log in '
          },
          {
            link: '/register',
            title: 'Sign up'
          }
        ]}
        onSubmit={(values, actions) => {
          submitLogin(values, actions)
            .finally(() => actions?.setSubmitting(false))
        }}
      >
        {({isSubmitting}) => (
          <>
            <div className={'form-block'}>
              <Input
                name={'login'}
                placeholder={'Login or e-mail'}
                variant={'login'}
              />
            </div>

            <div className={'form-block'}>
              <Input
                name={'password'}
                type={'password'}
                placeholder={'Password'}
                variant={'pass'}
              />
            </div>

            <div className="forgot-password">
              <Link to={"/user/forgot"}>
                {getLocalizeString('Forgot password?')}
              </Link>
            </div>

            {showCaptcha && <Captcha/>}

            <div className={'form-block'}>
              <Button
                text={'Log in'}
                type={'blue'}
                submit
                size={(appType === 'pro') ? 'big' : ''}
                isLoading={isSubmitting}
              />
            </div>

            {(appType === 'default') && (
              <div className={'form-block'}>
                <Button
                  text={'Sign up'}
                  type={'white'}
                  link={'/register'}
                />
              </div>
            )}
          </>
        )}
      </Form>
    </>
  )
}

export default Login
